import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScrapAgentListComponent } from './scrapAgentList.component';


const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Scrap Agent Management'
        },
        children: [
            {
                path: '',
                component: ScrapAgentListComponent,
                data: {
                    title: 'Scrap Agent List'
                }
            },
            {
                path: 'scrapAgentList',
                component: ScrapAgentListComponent,
                data: {
                    title: 'Scrap Agent List'
                }
            }
        ]
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ScrapAgentRoutingModule { }
